import React from 'react';
import { SvgIcon } from '@mui/material';

export default function AiProgramIcon({ active, sx, ...props }) {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      sx={{ width: 24, height: 25, ...sx }}
      {...props}
    >
      <rect
        y="0.260742"
        width="24"
        height="24"
        rx="8"
        fill={active ? '#29EDFF' : '#4520AB'}
      />
      <path
        d="M15.8087 12.1243L15.6447 12.5105C15.619 12.5733 15.5758 12.627 15.5204 12.6648C15.465 12.7026 15.3999 12.7228 15.3333 12.7228C15.2668 12.7228 15.2017 12.7026 15.1463 12.6648C15.0909 12.627 15.0476 12.5733 15.022 12.5105L14.858 12.1243C14.5697 11.4412 14.0416 10.8936 13.378 10.5893L12.872 10.3581C12.8106 10.3292 12.7586 10.2829 12.7222 10.2246C12.6857 10.1664 12.6663 10.0987 12.6663 10.0296C12.6663 9.96043 12.6857 9.89273 12.7222 9.83451C12.7586 9.77629 12.8106 9.72999 12.872 9.70109L13.35 9.48346C14.0303 9.17058 14.5674 8.60264 14.8507 7.89662L15.0193 7.47979C15.0441 7.41522 15.0873 7.35979 15.1433 7.32071C15.1993 7.28164 15.2655 7.26074 15.3333 7.26074C15.4011 7.26074 15.4673 7.28164 15.5233 7.32071C15.5794 7.35979 15.6226 7.41522 15.6473 7.47979L15.816 7.89594C16.099 8.60209 16.6359 9.17028 17.316 9.48346L17.7947 9.70177C17.8559 9.73075 17.9077 9.77705 17.944 9.8352C17.9803 9.89334 17.9996 9.96091 17.9996 10.0299C17.9996 10.0989 17.9803 10.1665 17.944 10.2246C17.9077 10.2828 17.8559 10.3291 17.7947 10.3581L17.288 10.5887C16.6245 10.8932 16.0967 11.4411 15.8087 12.1243ZM5.88533 13.4014L8.714 16.2961L7.77133 17.2607L4 13.4014L7.77133 9.54213L8.71333 10.5068L5.88533 13.4014ZM16.2287 17.2607L20 13.4014L18.1133 11.4721L17.1707 12.4368L18.114 13.4014L15.286 16.2961L16.2287 17.2607Z"
        fill="white"
      />
    </SvgIcon>
  );
}
